import { t } from 'i18next';
import * as yup from 'yup';

export const editNoteSchema = () =>
  yup.object().shape({
    content: yup.string().label(t('labelNote')).nullable().required(),
  });
